import { Component, effect, inject, untracked } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth/services/auth.service';
import { Navigation } from './core/navigation/navigation';
import { FloatingChat } from './core/floating-chat/floating-chat';
import { ReadOnlyBanner } from './core/banners/read-only-banner/read-only-banner';
import { ReleaseNotesService } from './release-notes/release-notes.service';
import { SchoolService } from './schools/services/school-service/school-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navigation, FloatingChat, ReadOnlyBanner],
  templateUrl: './app.html',
})
export class App {
  readonly authService = inject(AuthService);
  private readonly releaseNotes = inject(ReleaseNotesService);
  private readonly schoolService = inject(SchoolService);

  constructor() {
    // What is new is offered once the user is inside the app — after the login, and after the
    // terms too, so it never stacks on top of the acceptance page. At app start the session is
    // only a stored token until the first request answers: an expired one would open the dialog
    // over the login page the `401` is about to redirect to, and mark the notes seen there. So
    // this also waits for the school list, the request every app start makes.
    effect(() => {
      if (
        this.authService.isAuthenticated() &&
        this.authService.hasAcceptedCurrentTerms() &&
        !this.schoolService.isInitialLoading()
      ) {
        untracked(() => this.releaseNotes.showIfUnseen());
      }
    });
  }
}
